<script setup lang="ts">
import { INSTANT_EXPEDITIONS, REGULAR_EXPEDITIONS } from '~/shared/expedition'

const solutions = [
  'Jangkauan pengiriman luas, bisa kirim ke seluruh Indonesia.',
  'Bebas kirim paket berapa pun, tanpa minimum jumlah paket.',
  'Sistem terintegrasi dan otomatis, tak perlu ribet ganti aplikasi dan mendukung pembayaran COD.'
]

const expeditions = [...REGULAR_EXPEDITIONS, ...INSTANT_EXPEDITIONS]
</script>

<template>
  <div class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionWrapper
      class="bg-transparent dark:bg-transparent"
      title="Hari ini kirim paket <span class='text-primary'>Jadi Lebih Mudah</span>"
      title-as="h2"
      description="Pengiriman Instan, Same Day, Next Day, Reguler, Ekonomi, dan Kargo didukung oleh lebih dari 15 ekspedisi ke seluruh Indonesia dalam satu platform."
      hero-image="/assets/home-v4/frame-solusi-pengiriman.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-11">
          <div class="flex flex-col gap-6 text-lg leading-7">
            <div
              v-for="(solution, index) in solutions"
              :key="index"
              class="flex gap-2"
            >
              <Icon
                class="text-primary flex-none"
                name="material-symbols:verified"
                size="24px"
              />
              <p class="text-sm lg:text-lg flex-1">
                {{ solution }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
    <UiContainer class="flex flex-wrap items-center justify-center gap-3">
      <UiCourierCard
        v-for="(expedition, index) in expeditions"
        :key="index"
        :code="expedition.courier"
        :company-name="expedition.company_name"
        :icon="expedition.icon"
        :class="expedition.class"
      />
    </UiContainer>
  </div>
</template>
